import { logEvent } from '../common/logs';

/**
 * @deprecated For new eventus, use rather trackEventGA4 with event_name and params
 */
export const trackEvent = (category: string, action: string, label?: string, value?: number) =>
    trackEventGA4('EventTrigger', {
        event: 'EventTrigger',
        EventCategory: category || 'Unknown',
        EventAction: action || 'Unknown',
        EventLabel: label || 'Unknown',
        EventValue: value ? Math.round(value) : 0
    });

export const trackEventGA4 = (event_name: string, params: Record<string, any> = {}) => {
    const timeoutPromise = new Promise<void>(resolve => setTimeout(resolve, 1000));
    const eventPromise = new Promise<void>(resolve => {
        const data = {
            event: event_name,
            eventCallback: resolve,
            ...params
        };

        logEvent('GTM', `${data.event}`, data, 'yellow');
        pushEvent(data);
    });

    return Promise.race([eventPromise, timeoutPromise]);
};

export const trackVirtualPageView = (url?: string, title?: string) => {
    const event = {
        event: 'VirtualPageView',
        virtualPageURL: `/virtual-page/${url ?? '(not set)'}`,
        virtualPageTitle: title ?? '(not set)'
    };

    logEvent('GTM', `${event.event} | ${event.virtualPageURL} | ${event.virtualPageTitle}`, event, 'yellow');
    pushEvent(event);
};

export const pushEvent = (data: Record<string, any>) => {
    window.dataLayer = window.dataLayer || [];
    try {
        window.dataLayer.push(data);
    } catch (e) {
        console.error('Error while pushing event into dataLayer!', e);
    }
};
